import styled from 'styled-components';
import {
  RadioButton,
  Input,
  DatePicker,
  Checkbox
} from 'components/ProfileUIComponents';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button as Btn, Flexbox, Text } from '@morressier/ts';

export const Container = styled.div`
  margin-bottom: 2rem;
`;

export const InlineContainer = styled.div`
  margin-bottom: 0.7rem;
  display: inline-flex;
`;

export const InfoContainer = styled.div`
  margin-top: 2rem;
`;
export const SmallText = styled(Text)`
  width: 35rem;
`;
export const SmallInput = styled(Input)`
  width: 17rem;
  margin-top: 8px;
`;

export const ShortInput = styled(Input)`
  width: 24rem;
`;
export const MediumInput = styled(Input)`
  width: 35rem;
  margin: 8px 0;
`;

export const SearchInput = styled(Input)`
  width: 33rem;
`;

export const SearchButton = styled(Btn)`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 40px;
  color: var(--color-blue-40);
  border: 1px solid var(--color-blue-40);
  margin-top: 2rem;
`;

export const FieldContainer = styled.div`
  margin-right: 1rem;
`;

export const MonthPicker = styled(DatePicker)`
  margin: 8px 0;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin: 8px 0;
`;

export const StartDatePicker = styled(MonthPicker)`
  position: unset;
`;

export const StyledRadio = styled(RadioButton)`
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 4px;
  label:focus-within {
    outline: none;
  }
  &:focus-within {
    outline: var(--focus-style);
    outline-offset: 2px;
  }
`;

export const StyledRadioOrg = styled(Text)`
  padding: 1rem;
  border: 1px solid gray;
  border-radius: 4px;
  label:focus-within {
    outline: none;
  }
  &:focus-within {
    outline: var(--focus-style);
    outline-offset: 2px;
  }
`;

export const Department = styled(Text)`
  color: var(--color-mono-40);
`;

export const FormContainer = styled.div<{ showExitModal: boolean }>`
  height: 100%;
  display: ${({ showExitModal }) => (showExitModal ? 'none' : 'block')};
`;

export const Loader = styled(FontAwesomeIcon)`
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Warning = styled(Flexbox)`
  padding: 8px;
  gap: 8px;
  border-radius: 4px;
  align-items: center;
  background-color: var(--color-yellow-60);
  svg {
    font-size: var(--fontSizes-m);
  }
`;

export const Info = styled(Warning)`
  background-color: var(--color-mono-95);
`;

export const ModalForm = styled.form`
  height: 100%;
`;

export const LinkButtonStyle = styled.button`
  color: var(--color-blue-40);
  border: none;
  border-radius: 0.25rem;
  display: block;
  padding: 0;
  background: none;
  font-size: var(--fontSizes-normal);
  cursor: pointer;
  &:hover,
  &:focus {
    color: var(--color-blue-20);
  }
`;

export const OrgizationNoFoundWarning = styled(FieldContainer)`
  padding: 6px;
  border-radius: 4px;
  align-items: center;
  background-color: var(--color-yellow-60);
  svg {
    font-size: var(--fontSizes-m);
  }
`;
